export default "__VITE_ASSET__6f7de49c__"